import type { PaymentPlatform } from '../types'
import type { DeployEnv } from './monthly-no-trial'
import type { Product, SubscriptionProduct } from './types'

export interface Monthly7daysTrialConfig {
  product_id: number
  sku: string
}

// Arm B rescue product (monthly + 7-day trial). Service-API product_id is 114 on
// production / staging and 97 on dev. china_android is null — the rescue offer is
// iOS / Google Play only.
export const MONTHLY_7DAYS_TRIAL: Record<
  DeployEnv,
  Record<PaymentPlatform, Monthly7daysTrialConfig | null>
> = {
  production: {
    ios: { product_id: 114, sku: 'forest_monthly_early_bird_4' },
    googleplay_android: {
      product_id: 114,
      sku: 'forest_plus-monthly-early-bird-4',
    },
    china_android: null,
  },
  staging: {
    ios: { product_id: 114, sku: 'forest_monthly_early_bird_4' },
    googleplay_android: {
      product_id: 114,
      sku: 'forest_plus-monthly-early-bird-4',
    },
    china_android: null,
  },
  dev: {
    ios: { product_id: 97, sku: 'forest_monthly_early_bird_4' },
    googleplay_android: {
      product_id: 97,
      sku: 'forest_plus-monthly-early-bird-4',
    },
    china_android: null,
  },
}

/**
 * Builds the Arm B "rescue" product (monthly plan with a 7-day trial) from a
 * hardcoded `{ product_id, sku }` config, merging price / offers / trial-days
 * from the native subscription product when available. Mirrors
 * `buildAnnualDoubleTrial`; the trial is a native-applied introductory offer, so
 * no `offer_id` is selected here.
 */
export function buildMonthly7daysTrial(
  config: Monthly7daysTrialConfig,
  subscriptionProducts: SubscriptionProduct[],
): Product {
  const nativeProduct = subscriptionProducts.find((p) => p.sku === config.sku)
  return {
    product_id: config.product_id,
    receipt_system_product_id: 0,
    sku: config.sku,
    product_type: 'subscription',
    duration: 'monthly',
    eligible_trial_days: nativeProduct?.eligible_trial_days ?? 0,
    offers: nativeProduct?.offers,
    price_localized: nativeProduct?.price_localized ?? '',
    price_value: nativeProduct?.price_value ?? 0,
    display_name: nativeProduct?.display_name ?? '',
  }
}
